import { IShownFieldsSetAction } from './types';
import { AT_SHOWN_FIELDS_SET } from './constants';
import { TCardField } from '../types';

export const shownFieldsSetAction = (
    shownFields: TCardField[]
): IShownFieldsSetAction => ({
        type: AT_SHOWN_FIELDS_SET,
        shownFields
    }
);
